import { render, staticRenderFns } from "./relatedApproval.vue?vue&type=template&id=0942cb92&scoped=true"
import script from "./relatedApproval.vue?vue&type=script&lang=js"
export * from "./relatedApproval.vue?vue&type=script&lang=js"
import style0 from "./relatedApproval.vue?vue&type=style&index=0&id=0942cb92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0942cb92",
  null
  
)

export default component.exports